import { Validator } from '@vista-digital/validator';
import { monetaryValueValidator } from './monetary-value';
import { orderTicketRequestValidatorSchema } from './order/order-ticket-request';
import { ticketPriceBookingFeeValidator } from './ticket-price-booking-fee';
export const ticketDetailsValidator = Validator.object(Object.assign(Object.assign({}, orderTicketRequestValidatorSchema), { price: monetaryValueValidator, bookingFee: Validator.optional(ticketPriceBookingFeeValidator, { allowUndefined: true, allowNull: true }) }));
